import Modal from 'components/modal/modal'
import React, { useRef } from 'react'
import { removeItem } from 'store/localeStorage'
import setItem from 'utils/localStorage/setItem'
import './switch-parcours.scss'
const SwitchParcours: React.FC = () => {
   const [isOpen, setIsOpen] = React.useState(false)
   const lastTapRef = useRef<number>(0)
   const handleTouchStart = () => {
      const now = Date.now()
      const timeSinceLastTap = now - lastTapRef.current

      if (timeSinceLastTap < 500 && timeSinceLastTap > 0) {
         setIsOpen(true)
      }

      lastTapRef.current = now
   }
   return (
      <>
         <Modal isOpen={isOpen}>
            <div id='switch-parcours-buttons'>
               <button
                  onClick={() => {
                     setItem('parcours', 'visiteur')
                     setIsOpen(false)
                  }}
               >
                  Visiteur
               </button>
               <button
                  onClick={() => {
                     removeItem('parcours')
                     setItem('totem', 'Moulage')
                     setIsOpen(false)
                  }}
               >
                  Moulage
               </button>
               <button
                  onClick={() => {
                     removeItem('parcours')
                     setItem('totem', 'Assemblage')
                     setIsOpen(false)
                  }}
               >
                  Assemblage
               </button>
               <button onClick={() => setIsOpen(false)}>Annuler</button>
            </div>
         </Modal>
         <div id='switch-parcours' onTouchStart={handleTouchStart}></div>
      </>
   )
}

export default SwitchParcours
